import Link from 'next/link';
import React from 'react';
import styles from './styles.module.scss';
const BreadCrumbs = (props) => {
    const isLastCrumb = (index, totalCrumbs) => {
        return index < totalCrumbs - 1;
    };
    const prepareCrumbs = () => {
        let totalCrumbs = props.crumbs.length;
        return props.crumbs?.map((crumb, index) => {
            return (
                <React.Fragment key={index}>
                    <li className={`${styles.item} cursor-pointer`}>
                        {crumb.link !== '' ? (
                            <Link href={`${crumb.link}`}>
                                <a>{crumb.label}</a>
                            </Link>
                        ) : (
                            <>{crumb.label}</>
                        )}
                    </li>
                    {isLastCrumb(index, totalCrumbs) ? (
                        <span className={styles.right_arrow}>
                            <svg
                                width="8"
                                height="10"
                                viewBox="0 0 8 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M1 13L7 7L1 1"
                                    stroke="#666666"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </span>
                    ) : (
                        ''
                    )}
                </React.Fragment>
            );
        });
    };
    return (
        <ul
            className={`${styles.breadcrumb} ${props.className}`}
            style={props.style}
        >
            {prepareCrumbs()}
        </ul>
    );
};

export default BreadCrumbs;
